export const GST_RATE = 18
export const CGST_RATE = 9
export const SGST_RATE = 9
export const DEFAULT_SAC_CODE = '999293'
export const COMPANY_GSTIN = '29ACEFMI159N1ZR'
export const PLACE_OF_SUPPLY = 'Karnataka (29)'
export const SUPPLY_TYPE = 'Intra-State B2C Supply'
export const RECIPIENT_GSTIN = 'URP - Unregistered Consumer'

// price is treated as GST inclusive, split into taxable value + CGST + SGST
export function getGstBreakup(amount) {
  const total = Number(amount || 0)
  const taxable = total / (1 + GST_RATE / 100)
  const cgst = taxable * (CGST_RATE / 100)
  const sgst = taxable * (SGST_RATE / 100)
  return { taxable, cgst, sgst, total }
}

export function sumGstBreakup(items, priceKey = 'price') {
  return items.reduce((acc, item) => {
    const { taxable, cgst, sgst, total } = getGstBreakup(item?.[priceKey])
    return {
      taxable: acc.taxable + taxable,
      cgst: acc.cgst + cgst,
      sgst: acc.sgst + sgst,
      total: acc.total + total
    }
  }, { taxable: 0, cgst: 0, sgst: 0, total: 0 })
}

const ONES = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine', 'Ten',
  'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen']
const TENS = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety']

function threeDigitsToWords(n) {
  let str = ''
  if (n > 99) {
    str += `${ONES[Math.floor(n / 100)]} Hundred `
    n %= 100
  }
  if (n > 19) {
    str += `${TENS[Math.floor(n / 10)]} `
    n %= 10
  }
  if (n > 0) {
    str += `${ONES[n]} `
  }
  return str.trim()
}

export function numberToWords(num) {
  if (!num) return 'Zero'

  let value = Math.floor(num)
  let result = ''

  const crore = Math.floor(value / 10000000)
  value %= 10000000
  const lakh = Math.floor(value / 100000)
  value %= 100000
  const thousand = Math.floor(value / 1000)
  value %= 1000
  const hundred = value

  if (crore) result += `${threeDigitsToWords(crore)} Crore `
  if (lakh) result += `${threeDigitsToWords(lakh)} Lakh `
  if (thousand) result += `${threeDigitsToWords(thousand)} Thousand `
  if (hundred) result += threeDigitsToWords(hundred)

  return result.trim()
}

export function amountInWords(value) {
  const rounded = Math.round(Number(value || 0) * 100) / 100
  const rupees = Math.floor(rounded)
  const paise = Math.round((rounded - rupees) * 100)

  let words = `Rupees ${numberToWords(rupees)}`
  if (paise > 0) {
    words += ` and ${numberToWords(paise)} Paise`
  }
  words += ' Only'

  return words
}
